import React from 'react';
import PropTypes from 'prop-types';

import TaskTitle from './TaskTitle';

const Task = ({
  title,
  isEditing,
  isCompleted,
  handleConfirmation,
  removeGuest,
  handleToggleEditing,
  setTitle
}) => (
  <li className='holder'>
    <TaskTitle
      className='task'
      isCompleted={isCompleted}
      isEditing={isEditing}
      handleTitleEdits={e => setTitle(e.target.value)}
    >
      {title}
    </TaskTitle>

    <div className='buttons'>
      <button className='checkBtn btn' onClick={handleConfirmation}>
        <i className='fas fa-check' />
      </button>
      <button className='editBtn btn' onClick={handleToggleEditing}>
        {isEditing ? 'save' : 'edit'}
      </button>
      <button className='removeBtn btn' onClick={removeGuest}>
        <i className='fas fa-trash-alt' />
      </button>
    </div>
  </li>
);

Task.propTypes = {
  title: PropTypes.string.isRequired,
  isEditing: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  handleConfirmation: PropTypes.func.isRequired,
  removeGuest: PropTypes.func.isRequired,
  handleToggleEditing: PropTypes.func.isRequired,
  setTitle: PropTypes.func.isRequired
};

export default Task;
